export default __webpack_public_path__ + "static/media/ImagePlaceholder.28dc2bff.svg";